import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import ConfigUrl from "../../config"
import secureLocalStorage from "react-secure-storage"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Casestudyquote from "../../assets/images/CaseStudyIcon.avif"
import { FiRepeat } from "react-icons/fi"
import { FaChartLine } from "react-icons/fa"
import { BsFileEarmarkText } from "react-icons/bs"
import {
  MdAssignment,
  MdOutlineKeyboardArrowRight,
  MdOutlineMarkEmailUnread,
  MdOutlineKey,
} from "react-icons/md"
import { FiMapPin } from "react-icons/fi"
import { FaReact } from "react-icons/fa"

const CasestudyDetail = () => {
  const { id } = useParams()
  const [mainImg, setmainImg] = useState();
  const [imgViewer, setImgViewer] = useState(false);
  const [images, setImages] = useState([]);
  const portfolioId = secureLocalStorage.getItem("portfolioId")
  const [data, setdata] = useState({})
  const [project_images, setProject_images] = useState([])
  const [testimonial_images, setTestimonial_images] = useState([])
  const [Loading, setLoading] = useState(false)
  const [parsedResults, setparsedResults] = useState([])
  const [websiteLogo, setWebsiteLogo] = useState('');

  const icons = [
    FiRepeat,
    FaChartLine,
    BsFileEarmarkText,
    MdAssignment,
    FiMapPin,
    FaReact,
  ]

  async function getUserIP() {
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      return data.ip
    } catch (error) {
      console.error("Failed to get IP address:", error)
      return null
    }
  }

  async function getCaseStudyData() {
    try {
      setLoading(true)
      const response = await axios.post(
        `${ConfigUrl.apiurl}/portfolio/case/study/${id}`,
        {
          ip: await getUserIP(),
          type: 'case_study',
          login_id: secureLocalStorage.getItem('loginId')
        },
        {
          headers: {
            Authorization: `${portfolioId}`,
          },
        }
      )

      if (response.data.success) {
        setdata(response.data.caseStudy)
        setparsedResults(
          JSON.parse(response?.data?.caseStudy?.achieved_results)
        )
        let parsedArray = response.data.caseStudy?.project_image
          ? JSON.parse(response.data.caseStudy?.project_image)
          : []
        parsedArray = parsedArray.map(path => path.replace(/\\/g, "/"))
        setProject_images(parsedArray)
        const images = JSON.parse(response?.data?.caseStudy?.project_image || [])
        setImages(images)
        setmainImg(images[0])

        let parsedTestimonialImageArray = response.data.caseStudy
          ?.testimonial_image !== "null"
          ? JSON.parse(response.data.caseStudy?.testimonial_image)
          : []
        parsedTestimonialImageArray = parsedTestimonialImageArray.map(path =>
          path.replace(/\\/g, "/")
        )
        setTestimonial_images(parsedTestimonialImageArray)

        setWebsiteLogo(
          JSON.parse(response?.data?.caseStudy?.websiteLogo || [])
        )
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCaseStudyData()
  }, [])

  const Navigate = useNavigate()

  const carouselSettings = {
    dots: false,
    arrows: false,
    infinite: images.length > 4, // only enable infinite if more than one slide
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const getClicks = async () => {
    const res = axios.post(
      `${ConfigUrl.apiurl}/portfolio/case/website/${id}`,
      {
        ip: await getUserIP(),
        type: 'website',
        login_id: secureLocalStorage.getItem('loginId')
      },
      {
        headers: {
          Authorization: `${portfolioId}`,
        },
      }
    )
  }

  const isVideo = (fileName) => fileName.toLowerCase().endsWith(".mp4");

  return (
    <>
      <Row className="bg-white p-4">
        <div className="d-flex flex-column flex-xl-row justify-content-between px-3">
          <h3 className="color-purple fw-bold">{data.project_name}</h3>
          <button className="btn bg-light fs-6 mobile-none" onClick={() => Navigate(-1)}>
            Back
          </button>
        </div>
        <div className="my-2 pt-2 Service-detail">
          <div className="col-xl-12">
            <div className="row align-items-center">
              <div className="col-xxl-8 col-md-7">
                <div className="main-img">
                  {/* <img
                    src={mainImg != null ? `${ConfigUrl.imageurl}/${mainImg}` : ''}
                    alt=""
                    onClick={() => setImgViewer(true)}
                    height={380}
                    className="object-fit-cover w-100"
                    style={{ borderRadius: '5px' }}
                  /> */}
                  {mainImg && isVideo(mainImg) ? (
                    <video
                      src={`${ConfigUrl.imageurl}/${mainImg}`}
                      height={400}
                      className="object-fit-cover w-100 caseStudy-img"
                      style={{ objectFit: "cover" }}
                      controls
                      autoPlay
                      muted
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  ) : (
                    <img
                      src={mainImg ? `${ConfigUrl.imageurl}/${mainImg}` : ""}
                      alt=""
                      onClick={() => setImgViewer(true)}
                      height={380}
                      className="object-fit-cover w-100 caseStudy-img"
                      style={{ objectFit: "cover" }}
                    />
                  )}
                </div>
              </div>
              <div className="col-xxl-4 col-md-5 mobile-none">
                <div className=" ">
                  <div className="">
                    {/* <Slider {...carouselSettings}>
                      <div>
                        <div className="row">
                          {images?.slice(0, 4)?.map((item, index) => {
                            return (
                              <div className="col-md-6 mb-4" key={index}>
                                <img
                                  src={`${ConfigUrl.imageurl}/${item}`}
                                  onClick={() => setmainImg(item)}
                                  alt=""
                                  className="w-100 h-190 caseStudy-img"
                                  height={180}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {images?.length > 4 ? (
                        <div>
                          <div className="row">
                            {images?.slice(4, 8)?.map((item, index) => {
                              return (
                                <div className="col-md-6 mb-4" key={index}>
                                  <img
                                    src={`${ConfigUrl.imageurl}/${item}`}
                                    onClick={() =>
                                      setmainImg(item.image_title)
                                    }
                                    alt=""
                                    className="w-100 h-190 caseStudy-img"
                                    height={180}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : null}
                    </Slider> */}
                    <Slider {...carouselSettings}>
                      {/* Slide 1: First 4 items */}
                      <div>
                        <div className="row">
                          {images?.slice(0, 4).map((item, index) => (
                            <div className="col-md-6 mb-4" key={index}>
                              {isVideo(item) ? (
                                <video
                                  src={`${ConfigUrl.imageurl}/${item}`}
                                  className="w-100 h-190 caseStudy-img"
                                  height={180}
                                  onClick={() => setmainImg(item)}
                                  muted
                                  preload="metadata"
                                  style={{ objectFit: "cover", cursor: "pointer" }}
                                />
                              ) : (
                                <img
                                  src={`${ConfigUrl.imageurl}/${item}`}
                                  onClick={() => setmainImg(item)}
                                  alt=""
                                  className="w-100 h-190 caseStudy-img"
                                  height={180}
                                  style={{ objectFit: "cover", cursor: "pointer" }}
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Slide 2: Next 4 items (if exist) */}
                      {images?.length > 4 && (
                        <div>
                          <div className="row">
                            {images.slice(4, 8).map((item, index) => (
                              <div className="col-md-6 mb-4" key={index}>
                                {isVideo(item) ? (
                                  <video
                                    src={`${ConfigUrl.imageurl}/${item}`}
                                    className="w-100 h-190 caseStudy-img"
                                    height={180}
                                    onClick={() => setmainImg(item)}
                                    muted
                                    preload="metadata"
                                    style={{ objectFit: "cover", cursor: "pointer" }}
                                  />
                                ) : (
                                  <img
                                    src={`${ConfigUrl.imageurl}/${item}`}
                                    onClick={() => setmainImg(item)}
                                    alt=""
                                    className="w-100 h-190 caseStudy-img"
                                    height={180}
                                    style={{ objectFit: "cover", cursor: "pointer" }}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-5">
            <div className="col-xl-5 pe-4">
              <h3 className="color-purple fw-bold">{data.project_name}</h3>
              <p
                className="lh-base mt-4 mb-3"
                dangerouslySetInnerHTML={{ __html: data?.project_overview }}
              ></p>
            </div>
            <div className="col-xl-5 pe-5 ">
              <h3 className="color-purple fw-bold">Problems</h3>
              <p
                className="lh-base mt-4 mb-3"
                dangerouslySetInnerHTML={{
                  __html: data.problem_information,
                }}
              ></p>
            </div>
            <div className="col-xl-2 d-flex ps-0 flex-column align-items-center ">
              <img
                src={`${ConfigUrl?.imageurl}/${websiteLogo}`}
                style={{ height: "100px", width: "100px" }}
                className="object-fit-cover mb-3"
              ></img>
              <a
                href={data?.website}
                onClick={() => getClicks()}
                target="__blank"
                className="text-dark d-flex fs-5 mb-2"
              >
                <h5>Visit Website</h5>
                <MdOutlineKeyboardArrowRight fontSize={20} />
              </a>
              {data?.credential_email && data?.credential_password && (
                <div className="credential-look">
                  <div className="d-flex mb-2">
                    <MdOutlineMarkEmailUnread fontSize={20} className="me-1" />
                    <h5>{data?.credential_email}</h5>
                  </div>
                  <div className="d-flex">
                    <MdOutlineKey fontSize={20} className="me-1" />
                    <h5 className="mb-0">{data?.credential_password}</h5>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className=" my-5">
            <h1 className="color-purple fw-bold text-center">
              Strategy & Approach
            </h1>
            <div className="row mt-4">
              <div className="col-xl-12">
                <p
                  className="lh-base mt-4 mb-3"
                  dangerouslySetInnerHTML={{
                    __html: data.strategy_and_approach,
                  }}
                ></p>
              </div>
            </div>
          </div>
          <div className=" my-5">
            <div className="row mt-4 text-center">
              <div className="my-5">
                <h1 className="color-purple fw-bold text-center">
                  Achieved Results
                </h1>
                <div className="row mt-4 text-center">
                  {parsedResults?.map((result, index) => {
                    const Icon = icons[index % icons.length] // get the icon component
                    return (
                      <div key={index} className="col-xl-4 py-4">
                        <Icon fontSize={40} className="mb-3" color="#5d0585" />
                        <p>{result}</p>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          {
            testimonial_images.length > 0 && (
              <div className="row my-5 align-items-center">
                <div className="col-xl-4 mt-4 d-flex justify-content-center">
                  {testimonial_images?.[0] &&
                    (/\.(mp4|webm|ogg)$/i.test(testimonial_images[0]) ? (
                      <video
                        controls
                        className="w-100 object-fit-cover"
                        src={`${ConfigUrl.imageurl}/${testimonial_images[0]}`}
                      />
                    ) : (
                      <div className="bd-testimonial-four-img">
                        <img
                          className="w-100 object-fit-cover caseStudy-img"
                          src={`${ConfigUrl.imageurl}/${testimonial_images[0]}`}
                          alt="testimonial"
                          height={150}
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    ))}
                </div>
                <div className="col-xl-8 mb-3">
                  <i
                    className="fas fa-quote-right"
                    style={{ fontSize: "30px", color: "#5d0585" }}
                  ></i>
                  <p
                    className="lh-base mt-3"
                    dangerouslySetInnerHTML={{ __html: data.testimonial }}
                  ></p>
                </div>
              </div>
            )
          }

        </div>

      </Row>
      <section
        className={`image-viewer ${imgViewer ? "showViewer" : ""
          } d-flex align-items-center`}
      >
        <div className="text-center py-5 w-100">
          <div className="text-center w-100">
            <img src={mainImg != null ? `${ConfigUrl.imageurl}/${mainImg}` : ''} alt="" height={500} className="mobile-image-heig" />
          </div>
        </div>
        <a className="close-btn" onClick={() => setImgViewer(false)}>
          <i className="fa fa-times"></i></a>
      </section>
    </>
  )
}

export default CasestudyDetail
